import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { Content } from '../../../_models';
import {AuthenticationService, NotificationService, ContentService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-content-detail',
  templateUrl: './content-detail.component.html',
  styleUrls: []
})
export class ContentDetailComponent implements OnInit {

  contentData: Content = null;
  loaded = false;
  loading = true;
  processing = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private contentSvc: ContentService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this content?")) {
      this.contentSvc.updateContent(this.contentData).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Content updated successfully!", "Update Content");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update content, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/tx/content']);
  }

  private loadDetail(id){
    this.contentSvc.getContent(id).subscribe(data => {
      this.contentData = data
      this.loaded = true;
      this.loading = false;
    });
  }
}
